import { render, staticRenderFns } from "./ManageDriver.vue?vue&type=template&id=40a12d1a&scoped=true&"
import script from "./ManageDriver.vue?vue&type=script&lang=js&"
export * from "./ManageDriver.vue?vue&type=script&lang=js&"
import style0 from "./ManageDriver.vue?vue&type=style&index=0&id=40a12d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a12d1a",
  null
  
)

export default component.exports